import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  Columns,
  Block,
  Content,
  StyledImage,
  TitleWrapper,
  LocationTag,
} from './styles';

// * Difference between this component and ValuesSection
// * This supports CTAs in cards, values supports CTA at bottom of section

// * sectionTiles {obj} richtext obj provided by primsic
// * items {array} array of data from prismic for each card. Contains a heading {string}, image src {string}, bodyCopy {string}, subHeading {string}, and cta info {string}

const LocationSection = ({ sectionId, data }) => {
  if (!data) return null;
  const {
    sectionTitleHtml,
    columnAlignment,
    colourOverrideBackground,
    colourOverrideText,
    items,
  } = data;

  const textColor = colourOverrideText
    ? `text-${colourOverrideText.toLowerCase()}`
    : 'text-Light';

  return (
    <Wrapper
      id={sectionId}
      colourOverrideBackground={colourOverrideBackground}
      className={textColor}
    >
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(sectionTitleHtml)}
        <Columns className="regular-columns" columns={4}>
          {items.map(
            (
              {
                itemImage,
                imageItemSharp,
                itemHeadingHtml,
                itemBodyCopyHtml,
                itemSubHeading,
                cta,
                ctaText,
                ariaLabel,
                queryString,
              },
              index
            ) => {
              return (
                <Block
                  className={columnAlignment}
                  key={`locations-${columnAlignment}-${index.toString()}`}
                >
                  {imageItemSharp && (
                    <StyledImage src={imageItemSharp} alt={itemImage.altTag} />
                  )}
                  <Content>
                    <TitleWrapper>
                      {ReactHtmlParser(itemHeadingHtml)}
                      {itemSubHeading.length > 0 && (
                        <LocationTag>
                          {RichText.asText(itemSubHeading)}
                        </LocationTag>
                      )}
                    </TitleWrapper>
                    {ReactHtmlParser(itemBodyCopyHtml)}
                    {cta.url && ctaText && (
                      <Link
                        to={cta.url}
                        ariaLabel={ariaLabel}
                        queryString={queryString}
                      >
                        {ctaText}
                      </Link>
                    )}
                  </Content>
                </Block>
              );
            }
          )}
        </Columns>
      </StyledContainer>
    </Wrapper>
  );
};

LocationSection.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

export default LocationSection;
